export default __webpack_public_path__ + "static/media/TL02.9cd93bc5.mp3";